export const statusType = {
  INITIAL: 'initial',
  PENDING: 'pending',
  READY: 'ready',
  ERROR: 'error',
};

export type StatusType = keyof typeof statusType;
